import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Award } from 'lucide-react';

const RIBBON_HTML = `
<div id="circle-r-ribbon" class="rg-award-lang-pt_PT" style="cursor: pointer; overflow: hidden; position: relative; display: flex; flex-direction: column; padding: 0; max-width: 174px; min-width: 174px; height: 135px; font: 400 10px/normal 'Akrobat Bold', 'Helvetica Neue', 'Arial', sans-serif; align-items: center; text-align: center; color: #000 !important; text-shadow: none; background: url(https://awards.infcdn.net/img/bg.svg) no-repeat; box-sizing: border-box;">
  <div class="r-ribbon_ahead" style="transform: rotate(-11deg); position: absolute; z-index: 4; top: -7px; left: 6px; letter-spacing: 0.2px; padding: 0;">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="160px" height="160px" viewBox="0 0 160 160" style="width: 160px; height: 160px; margin-top: 0;">
      <defs><path id="heading-arc" d="M 30 80 a 50 50 0 1 1 100 0"></path></defs>
      <text class="r-ribbon_ahead-heading" fill="#000" text-anchor="middle" style="font-size: 12px !important; font-family: 'Akrobat Bold', 'Helvetica Neue', 'Arial', sans-serif !important; line-height: 1; text-transform: uppercase !important;">
        <textPath startOffset="50%" xlink:href="#heading-arc">Excelente carnes</textPath>
      </text>
    </svg>
  </div>
  <p class="r-ribbon_year" style="color: #000; width: 140px; font: 22px/normal 'Akrobat Black', 'Helvetica Neue', 'Arial', sans-serif !important; font-style: italic !important; transform: rotate(-12deg); position: absolute; top: 41px !important; left: 12px !important; letter-spacing: 0.6px; text-align: center !important; padding: 0 !important; margin: 0 !important;">2026</p>
  <a href="https://pt.restaurantguru.com/Ruis-Restaurant-and-Steakhouse-Quarteira" class="r-ribbon_title" target="_blank" rel="noopener noreferrer" style="text-transform: uppercase; color: #fff !important; width: 140px; font-size: 9px !important; line-height: normal !important; font-family: 'Akrobat Bold', 'Helvetica Neue', 'Arial', sans-serif !important; font-style: italic !important; transform: rotate(-12deg); position: absolute; z-index: 5; top: 68px; left: 16px; letter-spacing: 0.4px !important; text-align: center !important; white-space: normal; padding: 0 !important; margin: 0 !important; text-decoration: none !important; border-bottom: none; box-shadow: none; height: 26px; display: flex; align-items: center; justify-content: center;">Rui's Restaurante (Vilamoura)</a>
  <div class="r-ribbon_ahead r-ribbon_ahead-bottom" style="top: auto; bottom: -14px; left: 26px; letter-spacing: 0.3px; transform: rotate(-13deg); height: 100% !important; max-width: 100%; padding: 0; position: absolute !important; z-index: 4;">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="120px" height="120px" viewBox="0 0 120 120" style="width: 120px; height: 120px; margin-top: 0;">
      <defs><path id="subheading-arc" d="M 12 60 a 48 48 0 0 0 96 0"></path></defs>
      <text class="r-ribbon_ahead-subh" fill="#000" text-anchor="middle" style="font: 12px/1 'Akrobat Regular', 'Helvetica Neue', 'Arial', sans-serif !important; text-transform: uppercase; letter-spacing: normal;">
        <textPath startOffset="50%" xlink:href="#subheading-arc"><a href="https://restaurantguru.com" target="_blank" rel="noopener noreferrer" style="font: 12px/1 'Akrobat Regular', 'Helvetica Neue', 'Arial', sans-serif !important; text-transform: uppercase; letter-spacing: 0.3px; text-decoration: none !important; border-bottom: none; box-shadow: none; padding: 0; margin: 0;">Restaurant Guru</a></textPath>
      </text>
    </svg>
  </div>
</div>
`;

export default function AwardsSection() {
  const { t } = useLanguage();

  // Inject the Restaurant Guru widget stylesheet once
  useEffect(() => {
    const href = 'https://awards.infcdn.net/2026/circle_v2.css';
    if (!document.querySelector(`link[href="${href}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
    }
  }, []);

  return (
    <section
      id="awards"
      data-testid="awards-section"
      className="section-padding bg-[#F0EAE1]"
    >
      <div className="section-container">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Copy */}
          <div className="space-y-6">
            <p className="overline">{t('awards.overline')}</p>
            <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-medium text-[#2A1E17]">
              {t('awards.title')}
            </h2>
            <div className="w-20 h-[2px] bg-[#8C5A2B]" />
            <p className="text-[#6B584B] text-lg leading-relaxed">
              {t('awards.description')}
            </p>
            <div className="flex items-center gap-3 text-[#8C5A2B]">
              <Award size={22} strokeWidth={1.5} />
              <span className="text-sm uppercase tracking-[0.2em]">
                {t('awards.badge')}
              </span>
            </div>
            <a
              href="https://pt.restaurantguru.com/Ruis-Restaurant-and-Steakhouse-Quarteira"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="awards-guru-link"
              className="inline-block text-sm text-[#8C5A2B] hover:text-[#2A1E17] underline underline-offset-4 transition-colors"
            >
              {t('awards.viewOn')} Restaurant Guru →
            </a>
          </div>

          {/* Right Column - Ribbon Badge */}
          <div className="flex justify-center lg:justify-end">
            <a
              href="https://pt.restaurantguru.com/Ruis-Restaurant-and-Steakhouse-Quarteira"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="awards-ribbon"
              className="hover:scale-105 transition-transform duration-300"
              dangerouslySetInnerHTML={{ __html: RIBBON_HTML }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
